
import { IWorkspace, IWorkspaceFolder, WorkbenchState, ISingleFolderWorkspaceIdentifier, IWorkspaceIdentifier, isSingleFolderWorkspaceIdentifier,
    IClientWorkspaceContextService as IWorkspaceContextService,
    IConfigurationOverrides,
    ConfigurationTarget,
} from '@workbench-stack/core';
import * as core from '@workbench-stack/core';
import { isEqualOrParent, isEqual } from '@vscode-alt/monaco-editor/esm/vs/base/common/resources';
import { URI } from '@vscode-alt/monaco-editor/esm/vs/base/common/uri';
import { injectable, inject, postConstruct } from 'inversify';
import { ApolloClient } from 'apollo-client';
import { ClientTypes as CommonTypes } from '@common-stack/client-core';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { FetchPolicy } from 'apollo-client';
import {merge } from 'lodash';
import { IUpdateConfigurationValueMutation, IUpdateConfigurationValueMutationVariables, UpdateConfigurationValueDocument  } from '@workbench-stack/core';





@injectable()
export class ConfigurationService extends core.AbstractWorkspaceConfigurationClientService implements core.IClientConfigurationService {

    constructor(
        @inject(core.ClientTypes.ILifecycleService)
        private lifecycleService: core.ILifecycleService,
        @inject(CommonTypes.ApolloClient)
        private client: ApolloClient<any>,
        @inject(CommonTypes.InMemoryCache)
        private cache: InMemoryCache,
        @inject(CommonTypes.UtilityClass)
        private utility,
        @inject(CommonTypes.Logger)
        protected logger,
    ) {
        super(logger);
    }

    @postConstruct()
    public async extInitialize() {
        if (!this.configuration) {
            await this.asyncInitializedConfigurationContainer();
        }
    }

    private async asyncInitializedConfigurationContainer(opts: { fetchPolicy: FetchPolicy} = { fetchPolicy: 'cache-first'}) {
        this.lifecycleService.when(core.LifecyclePhase.Ready).then(async () => {
            const { data: { getConfigurationData } } = await this.client.query<core.IGetConfiguration_WSQuery>({
                query: core.GetConfiguration_WSDocument,
                fetchPolicy: opts.fetchPolicy,
            });
            const { defaults, folders, user, workspace} = getConfigurationData;
            const convertedFolder = folders.reduce((acc, curr) => {
                return merge(acc, {[curr.id]: curr });
            }, {});
            this.configuration = core.AbstractWorkspaceService.parse({ defaults, folders: convertedFolder as any, user, workspace});
        });
    }

    public updateValue(key: string, value: any): Promise<void>;
    public updateValue(key: string, value: any, overrides: IConfigurationOverrides): Promise<void>;
    public updateValue(key: string, value: any, target: ConfigurationTarget): Promise<void>;
    public updateValue(key: string, value: any, overrides: IConfigurationOverrides, target: ConfigurationTarget): Promise<void>;
    public updateValue(key: string, value: any, overrides: IConfigurationOverrides, target: ConfigurationTarget, donotNotifyError: boolean): Promise<void>;
    public async updateValue(key: string, value: any, arg3?: any, arg4?: any, donotNotifyError?: any): Promise<void> {
        await this.client.mutate<IUpdateConfigurationValueMutation, IUpdateConfigurationValueMutationVariables>({
            mutation: UpdateConfigurationValueDocument,
            variables: {
                key,
                value,
                overrides: arg3,
                target: arg4,
                donotNotifyError
            },
        });
    }

    public async reloadConfiguration() {
        await this.asyncInitializedConfigurationContainer({ fetchPolicy: 'network-only'});
    }
}
